/**
 * Routes where the Alicia chatbot is forbidden to be displayed
 */
export const CHATBOT_FORBIDDEN_ROUTES = ['/login'] as const;

/**
 * Routes where the chatbot should be hidden (but not destroyed)
 */
export const CHATBOT_HIDDEN_PAGES = [
  '/apps/edit',
  '/ges',
  '/ges/about-sodexo',
  '/ges/about-management',
  '/workforce-sizing',
  '/my-tasks',
  '/accessibility',
] as const;

/**
 * Checks if the current route forbids the chatbot from being displayed
 * @param pathname - Current route pathname
 * @returns boolean indicating if chatbot is forbidden on this route
 */
export const isChatbotForbiddenRoute = (pathname: string): boolean => {
  return CHATBOT_FORBIDDEN_ROUTES.includes(pathname as (typeof CHATBOT_FORBIDDEN_ROUTES)[number]);
};

/**
 * Checks if the chatbot should be hidden on the current route
 * @param pathname - Current route pathname
 * @returns boolean indicating if the chatbot should be hidden
 */
export const isChatbotHiddenOnPage = (pathname: string): boolean => {
  return CHATBOT_HIDDEN_PAGES.includes(pathname as (typeof CHATBOT_HIDDEN_PAGES)[number]);
};
